<div class="send-calculation-dialog">
  <div class="dialog__close" (click)="close()" cdkFocusRegionstart>
    <span class="material-icons">close</span>
  </div>

  <h2 class="send-calculation-dialog__header">
    {{ 'SEND_CALCULATION_DIALOG_COMPONENT.header' | translate }}
  </h2>

  <div class="send-calculation-dialog__email-input">
    <app-text-field
            [errorsMap]="formFactoryService.errorsMap"
            [bean]="bean"
            [control]="formGroup.controls[EMAIL_CONTROL_KEY]"
            [fieldConfig]="formFactoryService.fieldConfig(EMAIL_CONTROL_KEY, formConfig)"
            [context]="'SEND_CALCULATION_DIALOG_COMPONENT'"
    >
    </app-text-field>
  </div>

  <div class="send-calculation-dialog__agreement">
    {{ 'SEND_CALCULATION_DIALOG_COMPONENT.agreement' | translate }}
  </div>

  <div class="send-calculation-dialog__button">
    <button class="send-offer__btn btn btn--blue btn--small-padding"
            (click)="submitForm()">
      <img class="send-offer__btn__icon" [src]="buttonIconPath">
      <span class="send-offer__btn__text">{{'SEND_CALCULATION_DIALOG_COMPONENT.buttonLabel' | translate}}</span>
    </button>
  </div>
</div>
